var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62,60h-2V32c0-2.206-1.794-4-4-4h-6c-2.206,0-4,1.794-4,4v28h-2V12c0-2.206-1.794-4-4-4h-6c-2.206,0-4,1.794-4,4v48h-2V42 c0-2.206-1.794-4-4-4h-6c-2.206,0-4,1.794-4,4v18H4v-8h4c1.104,0,2-0.896,2-2s-0.896-2-2-2H4v-6c1.104,0,2-0.896,2-2s-0.896-2-2-2 v-6h4c1.104,0,2-0.896,2-2s-0.896-2-2-2H4v-6c1.104,0,2-0.896,2-2s-0.896-2-2-2v-6h4c1.104,0,2-0.896,2-2S9.104,8,8,8H4V2 c0-1.104-0.896-2-2-2S0,0.896,0,2v58c0,2.206,1.794,4,4,4h58c1.104,0,2-0.896,2-2S63.104,60,62,60z M50,32h6v28h-6V32z M34,12h6v48 h-6V12z M18,42h6v18h-6V42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.742d846f.svg";
export { ForwardRef as ReactComponent };